module.exports = __webpack_public_path__ + "static/img/AndrewCapel.3dffeea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AndrewCapel.jpg
// module id = ZGe0
// module chunks = 0